'use client';

import React from 'react';
import Link from 'next/link';
import { Music, ArrowLeft, Home } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-indigo-950 flex flex-col items-center justify-center p-4">
      <div className="text-center max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-indigo-500/20 border border-indigo-400/30 flex items-center justify-center">
            <Music size={28} className="text-indigo-300" />
          </div>
        </div>

        {/* 404 */}
        <h1 className="text-8xl font-bold text-white/10 mb-2 tabular-nums">404</h1>
        <h2 className="text-2xl font-bold text-white mb-3">Page Not Found</h2>
        <p className="text-slate-400 text-sm mb-2">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <p className="text-indigo-400 text-xs font-semibold uppercase tracking-widest mb-10">
          Central Florida Vocal Arts
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => window.history?.back()}
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl border border-white/10 text-slate-300 hover:text-white hover:border-white/20 text-sm font-medium transition-all duration-150"
          >
            <ArrowLeft size={15} />
            Go Back
          </button>
          <Link
            href="/portal"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-all duration-150 shadow-lg shadow-indigo-900/40"
          >
            <Home size={15} />
            Back to Portal
          </Link>
        </div>
      </div>
      <footer className="absolute bottom-4 text-slate-600 text-xs">
        © 2026 Central Florida Vocal Arts
      </footer>
    </div>
  );
}